module.exports = __webpack_public_path__ + "static/media/DeleteBlue.77b456ad.svg";